export const centerTypeColors = {
  pediatric: 'bg-[#A0B2B4] text-white',
  adult: 'bg-[#AF8A48] text-white',
  whole_life: 'bg-[#713d43] text-white'
} as const

export const centerTypeLabels = {
  pediatric: 'PEDIATRIC',
  adult: 'ADULT',
  whole_life: 'WHOLE LIFE'
} as const

export type CenterType = keyof typeof centerTypeColors
